const desktopPanel = document.querySelector('.bundle-section__atc-box__line-items-desktop');
const desktopTrack = document.querySelector('.bundle-scrollwrap__track');
const desktopThumb = document.querySelector('.bundle-scrollwrap__thumb');
const desktopSlots = Array.from(document.querySelectorAll('.bundle-slot'));
const bundleProductsContainerMobile = document.querySelector('.bundle-section__atc-box__line-items-mobile');
const mobileTrack = document.querySelector('.bundle-mtray__track');
const mobileThumb = document.querySelector('.bundle-mtray__thumb');
const mobileSlots = Array.from(bundleProductsContainerMobile.children);
const mobilePlaceholderHTML = mobileSlots.length ? mobileSlots[0].querySelector('.bundle-mslot__media').innerHTML : '';

const addButtons = document.querySelectorAll('.atb-button');
const atcButton = document.querySelector('#AtcButton');
const atcRemaining = document.querySelector('[data-atc-remaining]');
const savingsLabel = document.querySelector('[data-bundle-savings]');
const boxHeading = document.querySelector('[data-bundle-heading]');
const nextDiscountBadges = document.querySelectorAll('[data-next-discount]');
const submitForm = document.querySelector('form.bundle-form');
const searchBar = document.querySelector('#BundleSearch');
const productCards = Array.from(document.querySelectorAll('.bundle-product-card'));
const emptyState = document.querySelector(".empty-state");
const productList = document.querySelector(".product-list");
const filterButtons = document.querySelectorAll('.bundle-section__filter-button');
const strikePrice = document.querySelector('#strike-price');
const strikePriceDesktop = document.querySelector('#strike-price-desktop');
const actualPrice = document.querySelector('#actual-price');
const atcBoxPrice = document.querySelector('.bundle-section__atc-box__price');
const bundleDiscountValue = Number(atcBoxPrice.dataset.bundleDiscount);

const bundleUnitSize = Number(submitForm.dataset.bundleSize);

// Single price of a fragrance in this bundle's size, taken from the first card
const referenceSlotItem = document.querySelector('.bundle-line-item__placeholder .bundle-slot__item');
const referencePriceCents = referenceSlotItem ? Number(referenceSlotItem.dataset.price) || 0 : 0;

// Incentive staircase from the bundle metaobject (see bundle.liquid): picks
// beyond the last full bundle (the 4th, 5th, 7th, ... of a 3-bundle) get the
// discount of their position after that bundle, the last step repeating, once
// at least one bundle is complete. 0 turns a step off; capped at 99 because
// the cart transform ignores a target price of 0.
const bundleIncentiveSteps = (submitForm.dataset.bundleIncentive || '')
    .split(',')
    .map((value) => Math.min(99, Math.max(0, Math.round(Number(value)) || 0)));

function incentivePercent(position) {
    if (bundleIncentiveSteps.length === 0) return 0;
    return bundleIncentiveSteps[Math.min(position, bundleIncentiveSteps.length) - 1];
}

const hasIncentive = bundleIncentiveSteps.some((percent) => percent > 0);

// Remainder picks in basket order: each is marked down by its own step
function incentiveCents(remainderPricesCents) {
    return remainderPricesCents.reduce((sum, cents, index) => sum + Math.round(cents * (100 - incentivePercent(index + 1)) / 100), 0);
}

// Cap on picks of the same product: one more would form a second identical
// all-same box, whose cart line Shopify clamps to quantity 1. Still the 2+1
// number (2 * 3 - 1) — it does not yet follow bundleUnitSize.
const maxSameProduct = 5;

// Cloned from the second set: unlike the first, it carries the incentive badges
const desktopSlotTemplates = desktopSlots.slice(bundleUnitSize, 2 * bundleUnitSize).map((slot) => slot.cloneNode(true));
const mobileSlotTemplates = mobileSlots.slice(bundleUnitSize, 2 * bundleUnitSize).map((slot) => slot.cloneNode(true));

function ensureSlotCapacity(count) {
    while (desktopSlots.length < count) {
        desktopSlotTemplates.forEach((template) => {
            const slot = template.cloneNode(true);
            desktopPanel.appendChild(slot);
            desktopSlots.push(slot);
        });
        mobileSlotTemplates.forEach((template) => {
            const slot = template.cloneNode(true);
            bundleProductsContainerMobile.appendChild(slot);
            mobileSlots.push(slot);
        });
    }
}

let basket = [];

function slotItemId(card) {
    return card.querySelector('.bundle-line-item__placeholder .bundle-slot__item').dataset.id;
}

// The picks survive leaving the page (switching to the 15ml bundle, opening a
// fragrance's PDP, ...): they are stored as fragrance variant IDs per bundle
// parent variant, so every bundle size keeps its own box.
const savedBasketKey = 'elusaBundleBasket:' + submitForm.dataset.variantId;
const savedBasketMaxAge = 7 * 24 * 60 * 60 * 1000;

function saveBasket() {
    try {
        if (basket.length === 0) {
            localStorage.removeItem(savedBasketKey);
        } else {
            localStorage.setItem(savedBasketKey, JSON.stringify({ savedAt: Date.now(), ids: basket.map(slotItemId) }));
        }
    } catch (e) {}
}

// Fragrances the page no longer renders (sold out, removed from the bundle)
// are dropped silently, like unknown handles in preselectFromUrl()
function restoreSavedBasket() {
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem(savedBasketKey)); } catch (e) {}
    if (!saved || !Array.isArray(saved.ids)) return;
    if (!(Date.now() - saved.savedAt < savedBasketMaxAge)) {
        saveBasket();
        return;
    }

    const cardsById = new Map();
    productCards.forEach((wrapper) => {
        const card = wrapper.querySelector('product-card');
        if (!card) return;
        const id = slotItemId(card);
        if (!cardsById.has(id)) cardsById.set(id, card);
    });

    saved.ids.forEach((id) => {
        const card = cardsById.get(String(id));
        if (!card) return;
        if (basket.filter((entry) => slotItemId(entry) === String(id)).length >= maxSameProduct) return;
        basket.push(card);
    });

    renderBasket();
}

addButtons.forEach((button) => {
    button.addEventListener('click', () => {
        const card = button.closest('product-card');

        const cardId = slotItemId(card);
        const sameCount = basket.filter((entry) => slotItemId(entry) === cardId).length;
        if (sameCount >= maxSameProduct) {
            showSubmitError('Derselbe Duft darf nicht öfter als 5 Mal hinzugefügt werden.');
            return;
        }
        submitError.hidden = true;

        basket.push(card);
        renderBasket();

        desktopSlots[basket.length - 1].scrollIntoView({ block: 'nearest' });
        mobileSlots[basket.length - 1].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
});

desktopPanel.addEventListener('click', (event) => {
    const removeButton = event.target.closest('.bundle-slot__item .bundle-slot__remove');
    if (!removeButton) return;
    const index = desktopSlots.indexOf(removeButton.closest('.bundle-slot'));
    if (index === -1 || !basket[index]) return;
    basket.splice(index, 1);
    renderBasket();
});

bundleProductsContainerMobile.addEventListener('click', (event) => {
    const slotElement = event.target.closest('.bundle-mslot');
    const index = mobileSlots.indexOf(slotElement);
    if (index === -1 || !basket[index]) return;
    basket.splice(index, 1);
    renderBasket();
});

function renderBasket() {
    let visibleSlots = Math.max(bundleUnitSize, Math.ceil(basket.length / bundleUnitSize) * bundleUnitSize);
    // With the incentive, a full set already shows the next (discounted) slot
    // as an invitation to add one more
    if (incentivePercent(1) > 0 && basket.length >= bundleUnitSize && basket.length % bundleUnitSize === 0) {
        visibleSlots += 1;
    }
    ensureSlotCapacity(visibleSlots);

    // Slots of a complete bundle cost the bundle price, not the incentive;
    // variant B keeps their badges anyway
    const bundledSlots = isVariantB() ? 0 : Math.floor(basket.length / bundleUnitSize) * bundleUnitSize;
    [desktopSlots, mobileSlots].forEach((slots) => {
        slots.forEach((slot, index) => {
            const badge = slot.querySelector('[data-incentive-badge]');
            if (badge) badge.hidden = index < bundledSlots;
        });
    });

    desktopSlots.forEach((slot, index) => {
        slot.hidden = index >= visibleSlots;

        const existingItem = slot.querySelector('.bundle-slot__item');
        if (existingItem) existingItem.remove();

        const card = basket[index];
        slot.classList.toggle('bundle-slot--filled', Boolean(card));

        if (card) {
            const template = card.querySelector('.bundle-line-item__placeholder');
            slot.insertAdjacentHTML('afterbegin', template.innerHTML);
        }
    });

    desktopPanel.classList.toggle('is-scrollable', visibleSlots > bundleUnitSize);
    bundleProductsContainerMobile.classList.toggle('is-scrollable', visibleSlots > bundleUnitSize);
    updateDesktopThumb();
    updateMobileThumb();

    mobileSlots.forEach((slotElement, index) => {
        slotElement.hidden = index >= visibleSlots;

        const card = basket[index];
        slotElement.classList.toggle('bundle-mslot--filled', Boolean(card));

        const media = slotElement.querySelector('.bundle-mslot__media');
        if (card) {
            media.innerHTML = card.querySelector('.bundle-line-item__placeholder-mobile').innerHTML;
        } else {
            media.innerHTML = mobilePlaceholderHTML;
        }
    });

    // Any count from one full bundle upwards can be bought: picks beyond the
    // last full bundle go into the cart as single products at their own price,
    // which is what updatePrices() already shows.
    atcButton.disabled = basket.length < bundleUnitSize;
    updateAtcRemaining();
    updateNextDiscount();

    updatePrices();
    saveBasket();
}

// Once a bundle is full, variant A's box heading and variant B's savings label
// and card badges show what the next pick saves, measured as what it adds to the cart
// total against the single price. That is the incentive step for picks after
// a full bundle; the pick completing the next bundle saves more, because the
// incentive picks before it move to the bundle price.
function updateNextDiscount() {
    const percent = basket.length >= bundleUnitSize ? nextPickSavings(basketPricesCents()) : 0;

    // Variant A shows the same savings in place of its box heading
    if (boxHeading) {
        boxHeading.textContent = percent > 0
            ? boxHeading.dataset.textExtra.replace('[percent]', percent)
            : boxHeading.dataset.textBase;
    }

    if (!isVariantB()) return;

    if (savingsLabel) {
        savingsLabel.textContent = percent > 0
            ? savingsLabel.dataset.textExtra.replace('[percent]', percent)
            : savingsLabel.dataset.textBase;
        savingsLabel.closest('.bundle-ab-panel-head').classList.toggle('is-extra', percent > 0);
    }
    nextDiscountBadges.forEach((badge) => {
        badge.textContent = '-' + percent + '%';
        badge.hidden = percent <= 0;
    });

    // The slots completing the second, third, ... bundle (6, 9, ... of a
    // 3-bundle) show their savings like the incentive slots show theirs
    const before = Array(2 * bundleUnitSize - 1).fill(referencePriceCents);
    const completionPercent = nextPickSavings(before);
    document.querySelectorAll('[data-completion-badge]').forEach((badge) => {
        badge.textContent = '-' + completionPercent + '%';
        badge.hidden = completionPercent <= 0;
    });
}

// Percent a further pick at the single price saves after picks with these
// prices: what it adds to the cart total against the single price
function nextPickSavings(pricesCents) {
    if (referencePriceCents <= 0) return 0;
    const addedCents = Math.round((totalFor(pricesCents.concat(referencePriceCents)) - totalFor(pricesCents)) * 100);
    return Math.round(100 - addedCents * 100 / referencePriceCents);
}

// A/B test variant B (class "bundle-ab-b" on <html>, see bundle.liquid). The
// bundle picker on the product page sets it on its own container instead.
function isVariantB() {
    return document.documentElement.classList.contains('bundle-ab-b') || Boolean(submitForm.closest('.bundle-ab-b'));
}

// Variant B's CTA counts down the fragrances still missing for a full bundle;
// the translated texts come from data attributes (see bundle.liquid)
function updateAtcRemaining() {
    if (!atcRemaining) return;
    const missing = bundleUnitSize - basket.length;
    if (missing <= 0) atcRemaining.textContent = atcRemaining.dataset.textDone;
    else if (missing === 1) atcRemaining.textContent = atcRemaining.dataset.textOne;
    else atcRemaining.textContent = atcRemaining.dataset.textOther.replace('[items]', missing);
}

function formatPrice(amount) {
    const value = amount.toFixed(2).replace('.', ',');
    return value + ' €';
}

function updateDesktopThumb() {
    const maxScroll = desktopPanel.scrollHeight - desktopPanel.clientHeight;
    desktopThumb.hidden = maxScroll <= 0;
    if (maxScroll <= 0) return;

    const trackHeight = desktopTrack.clientHeight;
    const thumbHeight = Math.round(trackHeight * desktopPanel.clientHeight / desktopPanel.scrollHeight);
    const offset = (desktopPanel.scrollTop / maxScroll) * (trackHeight - thumbHeight);
    desktopThumb.style.height = thumbHeight + 'px';
    desktopThumb.style.transform = 'translateY(' + offset + 'px)';
}

desktopPanel.addEventListener('scroll', updateDesktopThumb);

function updateMobileThumb() {
    const maxScroll = bundleProductsContainerMobile.scrollWidth - bundleProductsContainerMobile.clientWidth;
    mobileThumb.hidden = maxScroll <= 0;
    if (maxScroll <= 0) return;

    const trackWidth = mobileTrack.clientWidth;
    const thumbWidth = Math.round(trackWidth * bundleProductsContainerMobile.clientWidth / bundleProductsContainerMobile.scrollWidth);
    const offset = (bundleProductsContainerMobile.scrollLeft / maxScroll) * (trackWidth - thumbWidth);
    mobileThumb.style.width = thumbWidth + 'px';
    mobileThumb.style.transform = 'translateX(' + offset + 'px)';
}

bundleProductsContainerMobile.addEventListener('scroll', updateMobileThumb);

function basketPricesCents() {
    return basket.map((card) => {
        const price = Number(card.querySelector('.bundle-slot__item').dataset.price);
        return isNaN(price) ? 0 : price;
    });
}

// What picks with these prices cost in the cart: full bundles at the bundle
// price, the picks beyond them at their own price or, after a full bundle,
// marked down by the incentive
function totalFor(pricesCents) {
    const completeBundles = Math.floor(pricesCents.length / bundleUnitSize);
    const remainderPrices = pricesCents.slice(completeBundles * bundleUnitSize);
    const remainderCents = completeBundles > 0
        ? incentiveCents(remainderPrices)
        : remainderPrices.reduce((sum, price) => sum + price, 0);
    return completeBundles * currentBundlePrice() + remainderCents / 100;
}

function updatePrices() {
    const pricesCents = basketPricesCents();
    let itemsSum = pricesCents.reduce((sum, price) => sum + price, 0) / 100;

    const completeBundles = Math.floor(basket.length / bundleUnitSize);
    let actualTotal = totalFor(pricesCents);

    // Variant B prices an incomplete bundle as the full bundle it becomes:
    // the bundle price against the regular price of all its slots, the empty
    // ones at the single price every fragrance of this size shares.
    if (isVariantB() && completeBundles === 0) {
        const missingCents = (bundleUnitSize - basket.length) * referencePriceCents;
        actualTotal = currentBundlePrice();
        itemsSum = (pricesCents.reduce((sum, price) => sum + price, 0) + missingCents) / 100;
    }

    const showStrike = itemsSum > actualTotal;

    const actualText = formatPrice(actualTotal);
    const strikeText = formatPrice(itemsSum);

    atcBoxPrice.textContent = actualText;
    actualPrice.textContent = actualText;
    strikePrice.textContent = strikeText;
    strikePrice.hidden = !showStrike;
    strikePriceDesktop.textContent = strikeText;
    strikePriceDesktop.hidden = !showStrike;
}

// Discount-code preview (same co2 logic as price-preview.js on normal PDPs):
// with a code in the cart, the bundle parent's discounted price replaces the
// bundle price in the header and the ATC box, the header's savings follow it
// and the code is shown next to them.
const headerPrice = document.querySelector('[data-bundle-header-price]');
const headerCompare = document.querySelector('[data-bundle-header-compare]');
const headerSavings = document.querySelector('[data-bundle-header-savings]');
const headerCode = document.querySelector('[data-bundle-header-code]');
const panelCodes = document.querySelectorAll('[data-bundle-panel-code]');
const panelSavingsBase = savingsLabel ? savingsLabel.dataset.textBase : '';
const hero = document.querySelector('[data-bundle-hero]');
const heroBadge = hero ? hero.querySelector('[data-bundle-hero-badge]') : null;
const heroText = hero ? hero.querySelector('[data-bundle-hero-text]') : null;
// Without a code: "bis zu" the best savings over all sizes, as rendered
const heroBadgeOriginal = heroBadge ? { text: heroBadge.textContent, hidden: heroBadge.hidden } : null;
const heroTextOriginal = heroText ? heroText.innerHTML : '';
const headerPriceOriginal = headerPrice ? headerPrice.dataset.original : '';
const cartPromise = fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json());
let codeBundlePrice = null;
let activeCode = '';

// The inline script in bundle.liquid hides the header price while a code
// has no cached result; never keep it hidden longer than this.
setTimeout(() => document.documentElement.classList.remove('bundle-code-pending', 'bundle-code-refresh'), 4000);

function codePriceKey(code) {
    return 'elusaBundleCodePrice:' + code + ':' + submitForm.dataset.variantId;
}

function currentBundlePrice() {
    return codeBundlePrice === null ? bundleDiscountValue : codeBundlePrice;
}

// Savings of a full bundle at the code price against its fragrances bought singly
function codeSavingsPercent() {
    const fullCents = referencePriceCents * bundleUnitSize;
    const priceCents = Math.round(codeBundlePrice * 100);
    return fullCents > priceCents ? Math.round(100 - priceCents * 100 / fullCents) : 0;
}

function updateHeaderPrice() {
    const percent = codeBundlePrice === null ? 0 : codeSavingsPercent();
    const savingsText = headerSavings && percent > 0
        ? headerSavings.dataset.text.replace('[percent]', percent)
        : null;

    if (headerSavings) headerSavings.textContent = savingsText || headerSavings.dataset.original;
    if (savingsLabel) savingsLabel.dataset.textBase = savingsText || panelSavingsBase;
    [headerCode, ...panelCodes].forEach((codeLabel) => {
        if (!codeLabel) return;
        codeLabel.textContent = activeCode.toUpperCase();
        codeLabel.hidden = codeBundlePrice === null;
    });
    if (hero && heroBadge && heroText) {
        if (percent > 0) {
            heroBadge.textContent = hero.dataset.badgeCode.replace('[percent]', percent).replace('[code]', activeCode.toUpperCase());
            heroBadge.hidden = false;
            heroText.innerHTML = hero.dataset.textCode.replace('[percent]', percent);
        } else {
            heroBadge.textContent = heroBadgeOriginal.text;
            heroBadge.hidden = heroBadgeOriginal.hidden;
            heroText.innerHTML = heroTextOriginal;
        }
    }

    if (!headerPrice || !headerCompare) return;
    if (codeBundlePrice === null) {
        headerPrice.textContent = headerPriceOriginal;
        headerCompare.hidden = true;
        return;
    }
    headerPrice.textContent = codeBundlePrice.toFixed(2).replace('.', ',') + ' €';
    headerCompare.textContent = headerPriceOriginal;
    headerCompare.hidden = false;
}

async function loadCodeDiscount(cartRequest) {
    let next = null;
    try {
        const cart = await (cartRequest || fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json()));
        const codes = cart.discount_codes || [];
        if (codes.length > 0) {
            const code = codes[0].code || codes[0];
            activeCode = code;
            await co2.setDiscountCode(code);

            let variantTags = [];
            try { variantTags = JSON.parse(submitForm.dataset.variantTags || '[]') || []; } catch (e) {}
            const priceCents = Math.round(bundleDiscountValue * 100);
            const result = await co2.itemDiscountFull(
                Number(submitForm.dataset.productId),
                Number(submitForm.dataset.variantId),
                (submitForm.dataset.productTags || '').split(',').filter(Boolean),
                priceCents,
                1,
                false,
                false,
                Array.isArray(variantTags) ? variantTags : []
            );
            if (result && result.discPrice > 0 && result.discPrice < priceCents) {
                next = result.discPrice / 100;
            }
            try {
                sessionStorage.setItem(codePriceKey(code), next === null ? 'none' : String(next));
                codeBundlePrice = next;
                if (next !== null && codeSavingsPercent() > 0) sessionStorage.setItem(codePriceKey(code) + ':savings', String(codeSavingsPercent()));
            } catch (e) {}
        }
    } catch (error) {
        console.warn('[BundleDiscount]', error);
    }
    codeBundlePrice = next;
    updateHeaderPrice();
    updatePrices();
    updateNextDiscount();
    document.documentElement.classList.remove('bundle-code-pending', 'bundle-code-refresh');
}

function waitForCo2(callback, tries = 0) {
    if (typeof co2 !== 'undefined') callback();
    else if (tries < 60) setTimeout(() => waitForCo2(callback, tries + 1), 100);
}

waitForCo2(() => loadCodeDiscount(cartPromise));
// Removing or replacing the code in the cart drawer
['cart:refresh', 'cart:change'].forEach((eventName) => {
    document.addEventListener(eventName, () => waitForCo2(() => loadCodeDiscount()));
});

const submitError = document.querySelector('.bundle-form__error');

// Shopify's sold-out 422 for a bundle add names the parent line's product,
// not the component variant that is actually unavailable — and its other
// availability texts name no product at all. Stock numbers rendered into
// the page can't resolve this either (they aggregate all locations, not
// what the storefront can sell). So each component variant is probed once
// as a plain add: a 422 or a capped quantity marks the culprit, and every
// unit a probe added is removed again before returning.
async function probeSoldOutComponents(itemsArray, cartBefore) {
    const requested = new Map();
    itemsArray.forEach((item) => {
        // Single products beyond the last full bundle carry no components
        if (!item.properties) {
            const id = String(item.id);
            requested.set(id, (requested.get(id) || 0) + item.quantity);
            return;
        }
        item.properties._components.split(',').forEach((part) => {
            const [variantId, qty] = part.split(':');
            requested.set(variantId, (requested.get(variantId) || 0) + Number(qty) * item.quantity);
        });
    });

    // Propertyless quantities per variant: plain adds merge into these lines,
    // so this is the quantity a probed line gets reverted to.
    const rawQuantityBefore = new Map();
    cartBefore.items.forEach((item) => {
        if (Object.keys(item.properties || {}).length === 0) {
            rawQuantityBefore.set(String(item.variant_id), (rawQuantityBefore.get(String(item.variant_id)) || 0) + item.quantity);
        }
    });

    const cappedIds = [];
    for (const [id, quantity] of requested) {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
        });
        const responseJson = await response.json();

        if (!response.ok) {
            cappedIds.push(id);
            continue;
        }

        const line = responseJson.items && responseJson.items[0];
        if (!line) continue;
        const before = rawQuantityBefore.get(id) || 0;
        // add.js reports the merged line total, so anything below the
        // expected total means Shopify capped the add.
        if (line.quantity < before + quantity) cappedIds.push(id);
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: before })
        });
    }

    const names = cappedIds.map((id) => {
        const card = basket.find((entry) => slotItemId(entry) === id);
        if (!card) return null;
        const item = card.querySelector('.bundle-line-item__placeholder .bundle-slot__item');
        const title = item.querySelector('.bundle-slot__title').textContent.trim();
        const variantTitle = item.dataset.variantTitle;
        return variantTitle && variantTitle !== 'Default Title' ? title + ' - ' + variantTitle : title;
    }).filter(Boolean);

    if (names.length === 1) return "Das Produkt '" + names[0] + "' ist bereits ausverkauft.";
    if (names.length > 1) return "Die Produkte '" + names.join("', '") + "' sind bereits ausverkauft.";
    return null;
}

function showSubmitError(message) {
    submitError.textContent = message || 'Dein Bundle konnte nicht hinzugefügt werden. Bitte versuche es erneut.';
    submitError.hidden = false;
}

submitForm.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (basket.length < bundleUnitSize) return;

    submitError.hidden = true;

    // One cart line per distinct composition: the bundle parent variant is added
    // with the picked fragrances in `_components`, the cart transform expands the
    // line. Identical compositions collapse into the line quantity, so the native
    // quantity stepper works on bundle lines.
    const bundleCount = Math.floor(basket.length / bundleUnitSize);
    const compositions = new Map();

    for (let bundleIndex = 0; bundleIndex < bundleCount; bundleIndex++) {
        const groupCards = basket.slice(bundleIndex * bundleUnitSize, (bundleIndex + 1) * bundleUnitSize);

        const aggregated = new Map();
        groupCards.forEach((card) => {
            const item = card.querySelector('.bundle-line-item__placeholder .bundle-slot__item');
            const itemId = item.dataset.id;

            if (!aggregated.has(itemId)) {
                const variantTitle = item.dataset.variantTitle === 'Default Title' ? '' : item.dataset.variantTitle;
                aggregated.set(itemId, {
                    quantity: 0,
                    priceCents: Number(item.dataset.price) || 0,
                    discount: item.querySelector('[data-property]').value,
                    handle: item.dataset.handle,
                    title: item.querySelector('.bundle-slot__title').textContent.trim(),
                    variantTitle: variantTitle
                });
            }
            aggregated.get(itemId).quantity += 1;
        });

        // Sorted by variant ID so identical compositions always serialize identically;
        // the price (in cents) lets the cart transform compute the markdown
        const entries = Array.from(aggregated.entries()).sort((a, b) => a[0].localeCompare(b[0]));
        const componentsKey = entries.map(([itemId, entry]) => itemId + ':' + entry.quantity + ':' + entry.priceCents).join(',');

        if (compositions.has(componentsKey)) {
            compositions.get(componentsKey).quantity += 1;
        } else {
            compositions.set(componentsKey, {
                quantity: 1,
                discount: entries[0][1].discount,
                richComponents: entries
                    .map(([, entry]) => entry.handle + '##' + entry.title + '##' + entry.variantTitle + '##' + entry.quantity)
                    .join('|||')
            });
        }
    }

    const itemsArray = Array.from(compositions.entries()).map(([componentsKey, bundle]) => ({
        id: submitForm.dataset.variantId,
        quantity: bundle.quantity,
        properties: {
            "_components": componentsKey,
            "_bundleDiscount": bundle.discount,
            "_rich_components": bundle.richComponents
        }
    }));

    // Picks beyond the last full bundle: without the incentive, plain lines of
    // the fragrance variant itself, so they cost their regular price.
    const singles = new Map();
    const remainderCards = basket.slice(bundleCount * bundleUnitSize);
    remainderCards.forEach((card) => {
        const item = card.querySelector('.bundle-line-item__placeholder .bundle-slot__item');
        const itemId = item.dataset.id;
        if (!singles.has(itemId)) {
            const variantTitle = item.dataset.variantTitle === 'Default Title' ? '' : item.dataset.variantTitle;
            singles.set(itemId, {
                quantity: 0,
                priceCents: Number(item.dataset.price) || 0,
                handle: item.dataset.handle,
                title: item.querySelector('.bundle-slot__title').textContent.trim(),
                variantTitle: variantTitle
            });
        }
        singles.get(itemId).quantity += 1;
    });

    if (hasIncentive && singles.size > 0) {
        // With the incentive they go in as one more bundle parent line: the
        // cart transform expands it and marks the picks down to the target
        // price in _bundleDiscount, exactly like a bundle.
        const entries = Array.from(singles.entries()).sort((a, b) => a[0].localeCompare(b[0]));
        const remainderPrices = remainderCards.map((card) => Number(card.querySelector('.bundle-slot__item').dataset.price) || 0);
        const appliedPercents = remainderPrices.map((cents, index) => incentivePercent(index + 1)).filter((percent) => percent > 0);
        itemsArray.push({
            // Own parent product "Bundle Zusatzdüfte" instead of the bundle
            // variant, so discount codes can exclude these already marked-down picks
            id: 59793709826373,
            quantity: 1,
            properties: {
                "_components": entries.map(([itemId, entry]) => itemId + ':' + entry.quantity + ':' + entry.priceCents).join(','),
                "_bundleDiscount": (incentiveCents(remainderPrices) / 100).toFixed(2),
                "_bundleIncentive": Array.from(new Set(appliedPercents)).map((percent) => percent + '%').join(' + '),
                "_rich_components": entries
                    .map(([, entry]) => entry.handle + '##' + entry.title + '##' + entry.variantTitle + '##' + entry.quantity)
                    .join('|||')
            }
        });
    } else {
        singles.forEach((entry, itemId) => {
            itemsArray.push({ id: itemId, quantity: entry.quantity });
        });
    }

    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const formData = {
        items: itemsArray,
        sections: sectionsToBundle.join(',')
    };

    try {
      const cartBefore = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      const responseJson = await response.json();
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

      if (!response.ok) {
        const description = responseJson.description || responseJson.message || '';

        // Shopify's availability description reports wrong counts for expanded
        // bundle lines; show the actual per-variant cart limit instead.
        if (/Verfügbarkeit|availability/i.test(description)) {
          showSubmitError('Derselbe Duft darf als Bundle nicht öfter als 5 Mal zum Warenkorb hinzugefügt werden.');
        } else if (/ausverkauft|sold out/i.test(description)) {
          let componentMessage = null;
          try {
            componentMessage = await probeSoldOutComponents(itemsArray, cartBefore);
          } catch (probeError) {
            console.error('Error:', probeError);
          }
          showSubmitError(componentMessage || description);
        } else {
          showSubmitError(description);
        }

        if (cartContent.item_count > cartBefore.item_count) {
          document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
          );
        }
        return;
      }

      if (responseJson.sections) {
        cartContent['sections'] = responseJson['sections'];

        document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                    baseEvent: 'variant:add',
                    cart: cartContent
                }
            })
        );
      } else {
        // Without bundled sections, cart:change would crash the drawer's
        // onCartChange handler (it reads cart.sections unguarded); cart:refresh
        // lets the drawer refetch its own section instead.
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
        );
      }

      basket = [];
      renderBasket();
    } catch (error) {
      console.error('Error:', error);
      showSubmitError();
    }
})

searchBar.addEventListener("input", () => {
  applyFilters();
});

// Variant B hides the search field behind a toggle and the filters in a panel
const searchToggle = document.querySelector('[data-bundle-search-toggle]');
const searchBarWrapper = document.querySelector('.bundle-section__search-bar');
const filterToggle = document.querySelector('[data-bundle-filter-toggle]');
const filterPanel = document.querySelector('[data-bundle-filter-panel]');
const filterCount = document.querySelector('[data-bundle-filter-count]');
const activeFiltersContainer = document.querySelector('[data-bundle-active-filters]');
const mobileQuery = window.matchMedia('(max-width: 1031px)');

if (searchToggle) {
  searchToggle.addEventListener('click', () => {
    const open = searchBarWrapper.classList.toggle('is-open');
    searchToggle.setAttribute('aria-expanded', String(open));
    if (open) searchBar.focus();
  });
}

// On mobile the panel is a modal bottom sheet; on desktop a dropdown below
// the toolbar that closes on Escape or a click outside of it.
function openFilterPanel() {
  if (mobileQuery.matches) {
    filterPanel.showModal();
    document.documentElement.classList.add('bundle-ab-filter-open');
  } else {
    filterPanel.show();
  }
  filterToggle.setAttribute('aria-expanded', 'true');
}

function closeFilterPanel() {
  if (!filterPanel.open) return;
  filterPanel.close();
}

if (filterToggle && filterPanel) {
  filterToggle.addEventListener('click', () => {
    if (filterPanel.open) closeFilterPanel();
    else openFilterPanel();
  });

  filterPanel.addEventListener('close', () => {
    filterToggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('bundle-ab-filter-open');
  });

  filterPanel.querySelectorAll('[data-bundle-filter-close]').forEach((button) => {
    button.addEventListener('click', closeFilterPanel);
  });

  filterPanel.querySelector('[data-bundle-filter-reset]').addEventListener('click', () => {
    filterButtons.forEach((button) => button.classList.remove('active'));
    applyFilters();
  });

  // A click on the modal's backdrop targets the dialog itself
  filterPanel.addEventListener('click', (event) => {
    if (event.target === filterPanel) closeFilterPanel();
  });

  document.addEventListener('click', (event) => {
    if (!filterPanel.open || mobileQuery.matches) return;
    if (filterPanel.contains(event.target) || filterToggle.contains(event.target)) return;
    closeFilterPanel();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeFilterPanel();
  });

  // addEventListener on MediaQueryList is missing before Safari 14
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', closeFilterPanel);
}

// Chips of the selected panel filters, shown left of the "Filtern" button
if (activeFiltersContainer) {
  activeFiltersContainer.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-filter-value]');
    if (!chip) return;
    filterButtons.forEach((button) => {
      if (button.dataset.filterGroup === chip.dataset.filterGroup && button.dataset.filterValue === chip.dataset.filterValue) {
        button.classList.remove('active');
      }
    });
    applyFilters();
  });
}

// Variant B only: variant A's filter markup and behavior stay untouched
function renderFilterSummary(visibleCount) {
  if (!isVariantB() || !activeFiltersContainer || !filterPanel) return;

  filterButtons.forEach((button) => {
    button.setAttribute('aria-pressed', String(button.classList.contains('active')));
  });

  const texts = filterPanel.dataset;
  if (visibleCount === 0) filterCount.textContent = texts.textNone;
  else if (visibleCount === 1) filterCount.textContent = texts.textShowOne;
  else filterCount.textContent = texts.textShowOther.replace('[items]', visibleCount);

  activeFiltersContainer.replaceChildren(...Array.from(filterPanel.querySelectorAll('.bundle-section__filter-button.active')).map((button) => {
    const chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'bundle-ab-pill bundle-ab-chip';
    chip.dataset.filterGroup = button.dataset.filterGroup;
    chip.dataset.filterValue = button.dataset.filterValue;
    chip.setAttribute('aria-label', texts.textRemove.replace('[filter]', button.textContent.trim()));
    chip.innerHTML = '<span></span><svg aria-hidden="true" focusable="false" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-linecap="round"/></svg>';
    chip.firstChild.textContent = button.textContent.trim();
    return chip;
  }));
}

filterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    button.classList.toggle("active");
    applyFilters();
  });
});

function applyFilters() {
  const activeFilters = Array.from(filterButtons)
    .filter((button) => button.classList.contains("active"))
    .map((button) => ({
      group: button.dataset.filterGroup,
      value: button.dataset.filterValue,
    }));

  const filtersByGroup = {};
  activeFilters.forEach((filter) => {
    if (!filtersByGroup[filter.group]) {
      filtersByGroup[filter.group] = [];
    }
    filtersByGroup[filter.group].push(filter.value);
  });

  const activeFilterGroups = Object.keys(filtersByGroup);
  const searchBarInput = searchBar.value.toLowerCase();

  let visibleCount = 0;
  productCards.forEach((card) => {
    let matchesAllGroups = true;

    if (activeFilterGroups.length > 0) {
      for (const filterGroup of activeFilterGroups) {
        const cardFilterAttribute = `data-filter-group-${filterGroup}`;
        const cardFilterValue = card.getAttribute(cardFilterAttribute);

        if (!cardFilterValue) {
          matchesAllGroups = false;
          break;
        }

        const selectedValues = filtersByGroup[filterGroup];
        const cardFilterValues = cardFilterValue
          .split(",")
          .map((value) => value.trim())
          .filter((value) => value !== "");

        const hasMatch = cardFilterValues.some((value) =>
          selectedValues.includes(value)
        );

        if (!hasMatch) {
          matchesAllGroups = false;
          break;
        }
      }
    }

    const matchesSearch =
      searchBarInput === "" ||
      card.dataset.productTitle.toLowerCase().includes(searchBarInput);

    if (matchesAllGroups && matchesSearch) {
      card.classList.remove("hidden");
      visibleCount++;
    } else {
      card.classList.add("hidden");
    }
  });

  updateEmptyState();
  renderFilterSummary(visibleCount);
}

function updateEmptyState() {
  const visibleCards = productCards.filter(
    (card) => !card.classList.contains("hidden")
  );

  if (visibleCards.length === 0) {
    emptyState.classList.remove("hidden");
    productList.classList.add("hidden");
  } else {
    emptyState.classList.add("hidden");
    productList.classList.remove("hidden");
  }
}

// Title and short description share a 4-line budget: every extra line the
// title wraps to takes one clamp line away from the description.
function clampShortDescriptions() {
  const clamps = productCards.map((card) => {
    const title = card.querySelector('.productVendorTitle--custom');
    const description = card.querySelector('.short_description--productPage');
    if (!title || !description || !title.offsetHeight) return null;

    const style = getComputedStyle(title);
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2;
    const titleLines = Math.max(1, Math.round(title.offsetHeight / lineHeight));
    return { description, lines: Math.max(1, 4 - titleLines) };
  });

  clamps.forEach((clamp) => {
    if (!clamp) return;
    clamp.description.style.setProperty('-webkit-line-clamp', clamp.lines);
    clamp.description.style.setProperty('line-clamp', clamp.lines);
  });
}

let clampResizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(clampResizeTimeout);
  clampResizeTimeout = setTimeout(clampShortDescriptions, 150);
});
window.addEventListener('load', clampShortDescriptions);
clampShortDescriptions();

// Preselect fragrances from the URL, e.g. /products/bundles?bundle=383,501,384
// The values are product handles — Elusa numbers its fragrances, so the handle
// of "383" is literally "383" — which lets a campaign link open the builder
// with a box already filled. `products` is accepted as an alias.
//
// Handles the page does not render are skipped rather than reported: a card is
// only in the DOM when the product has an available variant in this bundle's
// ml size, so a link shared across the 15ml and 100ml builders legitimately
// resolves to different subsets, and a sold-out fragrance simply drops out.
//
// Returns whether the URL named any fragrances: such a link replaces the
// saved picks instead of adding to them.
function preselectFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const requested = (params.get('bundle') || params.get('products') || params.get('p') || '')
        .split(',')
        .map((value) => value.trim().toLowerCase())
        .filter(Boolean);

    if (requested.length === 0) return false;

    const cardsByHandle = new Map();
    productCards.forEach((wrapper) => {
        const card = wrapper.querySelector('product-card');
        const handle = (card && card.getAttribute('handle') || '').trim().toLowerCase();
        if (handle && !cardsByHandle.has(handle)) cardsByHandle.set(handle, card);
    });

    const skipped = [];
    requested.forEach((handle) => {
        const card = cardsByHandle.get(handle);
        if (!card) {
            skipped.push(handle);
            return;
        }

        const cardId = slotItemId(card);
        const sameCount = basket.filter((entry) => slotItemId(entry) === cardId).length;
        if (sameCount >= maxSameProduct) {
            skipped.push(handle);
            return;
        }

        basket.push(card);
    });

    if (skipped.length > 0) {
        console.warn('Bundle-Vorauswahl übersprungen:', skipped.join(', '));
    }

    renderBasket();
    return true;
}

if (!preselectFromUrl()) restoreSavedBasket();
updatePrices();
applyFilters();
